import React, { useEffect, useState } from "react";
import ApplicationForm from "./components/application-form";
import Breadcrumbs from "../../components/Breadcrumbs";
import styles from "./PreApplication.module.scss";
import useUserStore from "../../stores/user";
import Button from "../../components/new-button/index";
import PaychexLogo from '../../../../images/v2/paychex_logo.png'
import CopyIcon from '../../assets/svg/icons/common/copy'
import { toast, Toaster, ToastBar } from "react-hot-toast";
import { Helmet } from "react-helmet";

const PreApplication = ({ match }) => {
  const breadcrumbItems = [
    { label: "Applications", to: "/v2/applications" },
    { label: "Create application" }
  ];

  const [showBreadcrumbs, setShowBreadcrumbs] = useState(true);
  const user = useUserStore((state) => state.user);

  const handleHideBreadcrumbs = (shouldHide) => {
    setShowBreadcrumbs(!shouldHide);
  };

  return (
    <>
      {user == null && (
        <header className={styles.header}>
          <img src={PaychexLogo} alt="Paychex" />
          <Button
            variant="secondary"
            icon={<CopyIcon />}
          >
            Copy Link
          </Button>
        </header>
      )}

      <div className={styles.page}>
        {showBreadcrumbs && <Breadcrumbs items={breadcrumbItems} />}
        
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>Create app</h1>
          <span className={styles.draftBadge}></span>
        </div>

        <div className={styles.content}>
          <div className={styles.formContainer}>
            <ApplicationForm isMerchantFlow={true} onHideBreadcrumbs={handleHideBreadcrumbs} />
          </div>
        </div>
      </div>

      {/* Toaster global component */}
      <Toaster
        position="top-right"
        containerStyle={{}}
        toastOptions={{
          style: {
            borderRadius: "8px",
            background: "rgba(40, 39, 45, 0.85)",
            color: "#fff",
            padding: "16px 24px",
          },
          duration: 5000,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== "loading" && (
                  <button
                    className={styles.toast_dismissal_button}
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M12.8535 12.1462C12.9 12.1927 12.9368 12.2478 12.962 12.3085C12.9871 12.3692 13.0001 12.4343 13.0001 12.5C13.0001 12.5657 12.9871 12.6307 12.962 12.6914C12.9368 12.7521 12.9 12.8073 12.8535 12.8537C12.8071 12.9002 12.7519 12.937 12.6912 12.9622C12.6305 12.9873 12.5655 13.0003 12.4998 13.0003C12.4341 13.0003 12.369 12.9873 12.3083 12.9622C12.2476 12.937 12.1925 12.9002 12.146 12.8537L7.99979 8.70685L3.85354 12.8537C3.75972 12.9475 3.63247 13.0003 3.49979 13.0003C3.36711 13.0003 3.23986 12.9475 3.14604 12.8537C3.05222 12.7599 2.99951 12.6327 2.99951 12.5C2.99951 12.3673 3.05222 12.24 3.14604 12.1462L7.29291 7.99997L3.14604 3.85372C3.05222 3.7599 2.99951 3.63265 2.99951 3.49997C2.99951 3.36729 3.05222 3.24004 3.14604 3.14622C3.23986 3.0524 3.36711 2.99969 3.49979 2.99969C3.63247 2.99969 3.75972 3.0524 3.85354 3.14622L7.99979 7.2931L12.146 3.14622C12.2399 3.0524 12.3671 2.99969 12.4998 2.99969C12.6325 2.99969 12.7597 3.0524 12.8535 3.14622C12.9474 3.24004 13.0001 3.36729 13.0001 3.49997C13.0001 3.63265 12.9474 3.7599 12.8535 3.85372L8.70666 7.99997L12.8535 12.1462Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>

      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.min.js"></script>
        <link
          href="https://cdn.jsdelivr.net/npm/pdfjs-dist@3.9.179/web/pdf_viewer.min.css"
          rel="stylesheet"
        ></link>
      </Helmet>
      <Helmet
        script={[
          {
            type: "text/javascript",
            innerHTML: "window.pdfjsLib = pdfjsLib",
          },
        ]}
      />
    </>
  );
};

export default PreApplication; 